import * as React from 'react';
import './index.scss';

interface Props {
    name: string;
    required?: boolean;
    type: string;
    placeholder?: string;
    setRef?: React.RefObject<HTMLInputElement>;
    onKeyDown?: (e: React.KeyboardEvent) => void;
    onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
}

class Input extends React.Component<Props> {
    render(): JSX.Element {
        const { name, type, placeholder, required = false, setRef, onKeyDown, onChange } = this.props;

        return (
            <input ref={setRef} onKeyDown={onKeyDown} onChange={onChange} className="input" name={name} type={type} placeholder={placeholder} required={required} />
        )
    }
}

export default Input;


// WEBPACK FOOTER //
// ./src/components/layout/Input/index.tsx